import { useStepTwo } from 'Hooks/useStepTwo'
import ApSelect from '../ApSelect'
import ApSelectWeight from '../ApSelectWeight'
import { ApTextareaTwo } from '../ApTextareaTwo'
import { ApTextareaProps, matricType } from './ApStepTwo'

type StepTwo = ReturnType<typeof useStepTwo>

type ApStepTwoViewProps = ApTextareaProps & StepTwo

export const ApStepTwoDesktop: React.FC<ApStepTwoViewProps> = (props) => {
  const {
    register,
    errors,
    isManager,
    isAdmin,
    isDisabled,
    preview,
    isManagerDraft,

    kpi,
    kpiPercentage,
    kpiPercentageMgr,
  } = props

  return (
    <div>
      <div className='card kpi px-3 px-md-4 border-0 mt-3 mb-3'>
        <div className='card-header px-0'>Performance Evaluation & Feedback</div>
        <div className='card-body px-0'>
          <div className='row mb-3 heading'>
            <div className={!isManager && !isAdmin ? 'col-7 col-md-6 col-lg-7' : 'col-md-3'}>
              KPIs (up to 80%)
            </div>

            <div
              className={
                !isManager && !isAdmin
                  ? 'col-5 col-md-6 col-lg-5 d-flex gap-3'
                  : 'col-md-5 d-flex text-cente'
              }
            >
              <span
                className={
                  !isManager && !isAdmin ? 'col-2 head-offset-1-emp' : 'col-3 head-offset-1'
                }
              >
                Weight (%)
              </span>
              <span
                className={
                  !isManager && !isAdmin ? 'col-2 head-offset-0-emp' : 'col-2 head-offset-'
                }
              >
                Appraisee&rsquo;s Score
              </span>
              <span
                className={!isManager && !isAdmin ? 'col- head-offset-2-emp' : 'col- head-offset-1'}
              >
                Appraisee&rsquo;s Comment
              </span>
            </div>

            {isManager && (
              <div className={!isManager && !isAdmin ? '' : 'col-md-4 d-flex text-cente'}>
                <span className='col-3 head-offset-3'>Manager&rsquo;s Score</span>
                <span className='col- head-offset-4'>Manager&rsquo;s Comment</span>
              </div>
            )}
          </div>
          <ul className='list-group'>
            {kpi &&
              kpi.map((item: matricType, index: number) => (
                <li className='list-group-item list-item-icon' key={index}>
                  <div className='row align-items-start'>
                    <div
                      className={`flex-me-end ${!isManager && !isAdmin ? 'col-7 col-md-6 col-lg-7' : 'col-md-3'}`}
                    >
                      {/* <span className='first-child'>KPIs (up to 80%)</span> */}
                      <span className='second-child'> {item.metric}</span>
                    </div>

                    <div
                      className={`remove-it text-input-con ${
                        !isManager && !isAdmin
                          ? 'col-5 col-md-6 col-lg-5 d-flex gap-3 emp-inputs-offse inputs-mob-wrapper'
                          : 'col-md-5 d-flex gap-3'
                      }`}
                    >
                      <input
                        type='hidden'
                        {...register(`kpi.${index}.relevance`)}
                        value={item.relevance}
                      />

                      <input
                        type='hidden'
                        {...register(`kpi.${Number(index)}.metric`)}
                        value={item.metric}
                      />

                      <input
                        type='hidden'
                        {...register(`kpi.${Number(index)}.target`)}
                        value={Number(index)}
                      />
                      <input
                        type='hidden'
                        {...register(`kpi.${Number(index)}.employee_comment`)}
                        value={Number(index)}
                      />
                      <div className='kpi-select-con'>
                        {/* {!lgScreen ? (
                          <div className='flex-me-en px-0'>
                            <span className='first-child'>Weight (%)</span>
                            <ApSelectWeight
                              name={`kpi.${index}.relevance`}
                              index={index}
                              register={register}
                              errors={errors}
                              rules={!isAdmin ? { required: 'Field is required.' } : {}}
                              disable={isAdmin || isManager || !isDisabled}
                            />
                          </div>
                        ) : ( */}
                        <ApSelectWeight
                          name={`kpi.${index}.relevance`}
                          index={index}
                          register={register}
                          errors={errors}
                          rules={!isAdmin ? { required: 'Field is required.' } : {}}
                          disable={isAdmin || isManager || !isDisabled}
                        />
                        {/* )} */}
                      </div>
                      <div className='kpi-select-con'>
                        <ApSelect
                          name={`kpi.${index}.employee_score`}
                          index={index}
                          register={register}
                          errors={errors}
                          rules={{ required: 'Field is required.' }}
                          disable={preview ? true : isDisabled}
                        />
                      </div>

                      <div className='flex-grow-1 kpi-textarea-con'>
                        <ApTextareaTwo
                          name={`kpi.${index}.employee_comment`}
                          index={index}
                          register={register}
                          errors={errors}
                          rules={{ required: 'Field is required.' }}
                          placeholder='Type here...'
                          disabled={preview ? true : isManager || isAdmin}
                          isDisabled={isDisabled}
                        />
                        {/* <ApInput
                          name={`kpi.${index}.employee_comment`}
                          index={index}
                          register={register}
                          errors={errors}
                          placeholder='Type here...'
                          disabled={isDisabled}
                        /> */}
                      </div>
                    </div>

                    {isManager && (
                      <div className='col-md-4 d-flex gap-3'>
                        <div className='kpi-select-con'>
                          <ApSelect
                            name={isManagerDraft ? 'k' : `kpi.${index}.manager_score`}
                            index={index}
                            register={register}
                            errors={errors}
                            rules={!isAdmin ? { required: 'Field is required.' } : {}}
                            disable={isAdmin}
                          />
                        </div>

                        <div className='flex-grow-1 kpi-textarea-con'>
                          <ApTextareaTwo
                            name={isManagerDraft ? 'k' : `kpi.${index}.manager_comment`}
                            index={index}
                            register={register}
                            errors={errors}
                            placeholder='Type here...'
                            disabled={isAdmin}
                          />
                          {/* <ApInput
                            name={`kpi.${index}.manager_comment`}
                            index={index}
                            register={register}
                            errors={errors}
                            placeholder='Type here...'
                            disabled={isAdmin}
                          /> */}
                        </div>
                      </div>
                    )}
                  </div>
                </li>
              ))}
          </ul>

          <div
            className={
              !isManager && !isAdmin
                ? 'row d-flex justify-space-between heading'
                : 'row mt-3 align-items-center'
            }
          >
            <div className={!isManager && !isAdmin ? 'col-md-7' : 'col-md-3 total-offset-'}></div>
            <div
              className={
                !isManager && !isAdmin
                  ? 'col-md-1 ap-e-offset-2'
                  : 'col-md-1 total-offset-1 text-cente heading'
              }
            >
              {kpi && kpi?.length ? '100%' : '0.00%'}
            </div>
            <div
              className={
                !isManager && !isAdmin
                  ? 'col-md-3 ps-1 ap-e-offset-0'
                  : 'col-md-3 total-offset-3 text-cente heading'
              }
            >
              {kpiPercentage}%
            </div>

            {isManager && (
              <div className='col-md-1 total-inward-offset text-cente heading'>
                {isManagerDraft ? '0.00' : kpiPercentageMgr}%
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
